import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { connect } from "react-redux";
// import _ from "lodash";
import MaterialTable from 'material-table';
import { deleteWarehouseApi, updateWarehouseApi } from "./Warehouse.action";
import { setHeading } from "../../../accounts/account.actions";
import { baseURL, headers } from "../../../../../global/api";


const WarehouseTableList = (props) => {
    const permissions = JSON.parse(window.localStorage.getItem("permissions"))
    const Checkpermissions = (permissionsType, permissionsName) => {
        return permissions.some(p => p[`${permissionsType}`] === permissionsName) ? false : true
    }

    useEffect(() => {
        props.setHeading("Businnes Location Details");
    }, []);

    return (
        <>
            <Container fluid>
                <MaterialTable
                    title="Businnes Location Details"
                    columns={[
                        { title: 'Code', field: 'whKey', editable: 'never' },
                        { title: 'Business Name', field: 'businessName' },
                        { title: 'Location', field: 'location' },
                        { title: 'City', field: 'city' },
                        { title: 'Zip Code', field: 'zipCode' },
                        { title: 'State', field: 'state' },
                        { title: 'Country', field: 'country' },
                        { title: 'Contact', field: 'contact' },
                        { title: 'Description', field: 'description' },
                        { title: 'Manager', field: 'manager' },
                        { title: 'Created At', field: 'createdAt', type: 'date', dateSetting: { locale: "en-GB" } },
                    ]}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            let url = `${baseURL}/warehouse?`;
                            url += "limit=" + query.pageSize;
                            url += "&page=" + (query.page);
                            url += "&search=" + query.search;
                            fetch(url, {
                                method: 'GET',
                                headers: headers,
                            }).then((response) => response.json()).then((result) => {
                                resolve({
                                    data: result.data,
                                    page: result.page,
                                    totalCount: result.total_results,
                                });
                            });
                        })
                    }
                    options={{
                        actionsColumnIndex: -1,
                        exportButton: true,
                        exportAllData: true,
                        paging: true,
                        pageSize: 50,
                        emptyRowsWhenPaging: false,
                        pageSizeOptions: [50, 100, 150, 200],
                        headerStyle: {
                            position: "sticky",
                            top: 0,
                            color: "#00BBBB",
                            fontWeight: "550",
                            onRowAdd: "none",
                            whiteSpace: 'nowrap',
                        },
                        rowStyle: {
                            whiteSpace: 'nowrap',
                        },
                        cellStyle: {
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        },
                    }}
                    editable={{
                        isEditHidden: rowData => Checkpermissions("permissionsSubCatName", "Warehouse Edit"),
                        isDeleteHidden: rowData => Checkpermissions("permissionsSubCatName", "Warehouse Delete"),
                        onRowUpdate: (newData, oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    props.updateWarehouseApi(newData, oldData)
                                }, 600);
                            }),
                        onRowDelete: (oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    props.deleteWarehouseApi(oldData._id);
                                }, 600);
                            }),
                    }}
                />
            </Container>
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        deleteWarehouseApi: (_Id) => dispatch(deleteWarehouseApi(_Id)),
        updateWarehouseApi: (newData, oldData) => dispatch(updateWarehouseApi(newData, oldData)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(WarehouseTableList);